const videoGallery = {
  displayField: 'title',
  name: 'Video Gallery',
  description: '',
  fields: [
    {
      id: 'title',
      name: 'Title',
      type: 'Symbol',
      localized: true,
      required: true,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'videos',
      name: 'videos',
      type: 'Array',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
      items: {
        type: 'Link',
        validations: [ { linkContentType: [ 'videoGalleryVideo' ] } ],
        linkType: 'Entry'
      }
    }
  ],
  sys: {
    id: 'videoGallery',
    version: 16,
    updatedAt: '2023-08-03T14:43:47.578Z'
  }
};
export default videoGallery;